<template>
  <div id="toTop">
    <Header />
    <SystemHeader v-if="!($route.query.noSearch && $route.query.noSearch === 'true') && $route.meta.pageName !== '台州专区' && $route.meta.pageName !== '义乌专区' && $route.meta.pageName !== '黄岩专区' && $route.meta.pageName !== '海曙专区'" />
    <slot />
    <Footer />
  </div>
</template>

<script>
import Header from './Header'
import SystemHeader from './SystemHeader/index'
import Footer from './Footer'

export default {
  components: {
    Header,
    SystemHeader,
    Footer
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BasicLayout.vue